import { theme, styled } from 'ui/theme';

import ButtonBase from './ButtonBase';

const ButtonSolid = styled(ButtonBase)`
  background: ${theme.colors.action.navigation.standard.static};

  &:not([disabled]):hover {
    background: ${theme.colors.action.navigation.standard.highlight};
  }
`;

export default ButtonSolid;
